import * as Types from '../../../__generated__/schema';

import { ActorTeaserAPIToken, ActorTeaserUser } from './ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from './ActorTeaser.generated';
export type AlertActivityHistoryFull = {
  pageInfo: Pick<Types.AlertActivityHistoryOutputPageInfo, 'endCursor' | 'hasNextPage'>;
  edges: Array<{
    node: Pick<Types.AlertActivityHistoryRecord, 'id' | 'type' | 'createdAt'> & {
      triggeredBy: ActorTeaserAPIToken | ActorTeaserUser;
      content:
        | {
            newAssignee?: Types.Maybe<
              Pick<Types.User, 'email' | 'familyName' | 'givenName' | 'id' | 'enabled'>
            >;
          }
        | { comment: Pick<Types.Comment, 'id' | 'body' | 'format' | 'createdAt'> }
        | Pick<Types.AlertActivityHistoryContextTagsChange, 'newContextTags'>
        | Pick<Types.AlertActivityHistoryQualityChange, 'newQuality'>
        | {
            slackbotBoomerangHistory: Pick<
              Types.SlackbotBoomerangHistory,
              | 'id'
              | 'alertId'
              | 'question'
              | 'historyType'
              | 'recipientName'
              | 'responseAction'
              | 'responseMessage'
            >;
          }
        | Pick<Types.AlertActivityHistoryStatusChange, 'newStatus'>;
    };
  }>;
};

export const AlertActivityHistoryFull = gql`
  fragment AlertActivityHistoryFull on AlertActivityHistoryOutput {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        type
        triggeredBy {
          ...ActorTeaser
        }
        createdAt
        content {
          ... on AlertActivityHistoryStatusChange {
            newStatus
          }
          ... on AlertActivityHistoryAssigneeChange {
            newAssignee {
              email
              familyName
              givenName
              id
              enabled
            }
          }
          ... on AlertActivityHistoryCommentAdded {
            comment {
              id
              body
              format
              createdAt
            }
          }
          ... on AlertActivityHistorySlackbotBoomerang {
            slackbotBoomerangHistory {
              id
              alertId
              question
              historyType
              recipientName
              responseAction
              responseMessage
            }
          }
          ... on AlertActivityHistoryQualityChange {
            newQuality
          }
          ... on AlertActivityHistoryContextTagsChange {
            newContextTags
          }
        }
      }
    }
  }
  ${ActorTeaser}
`;
